import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import urlUtils from 'utils/Url';
import { Text, Link } from 'components/ui';
import Location from 'utils/Location';

function DisplayName({
    product, showPDPTopOfPageRedesign, is = 'h1', lineHeight = 'tight', marginBottom = [2, 3], ...rest
}) {
    const { brand, displayName } = product;

    return (
        <Text
            is={is}
            lineHeight={lineHeight}
            marginBottom={marginBottom}
            {...rest}
            {...(showPDPTopOfPageRedesign && { textAlign: 'left', marginBottom: 2 })}
        >
            {brand && brand.displayName && (
                <>
                    <Link
                        data-at={Sephora.debug.dataAt('brand_name')}
                        {...(showPDPTopOfPageRedesign ? { color: 'blue', fontSize: ['sm', 'base'], fontWeight: 'normal' } : { fontWeight: 'bold' })}
                        href={urlUtils.getLink(brand.targetUrl, ['product_link_brand'])}
                        onClick={e => {
                            Location.navigateTo(e, brand.targetUrl);
                        }}
                        children={brand.displayName}
                    />
                    &nbsp;
                    <br />
                </>
            )}
            <Text
                data-at={Sephora.debug.dataAt(rest.productDisplayNameDataAt || 'product_name')}
                {...(showPDPTopOfPageRedesign ? { fontSize: ['lg-bg', 'xl-bg'], fontWeight: 'bold' } : { fontSize: 'md' })}
                children={displayName}
            />
        </Text>
    );
}

export default wrapFunctionalComponent(DisplayName, 'DisplayName');
